import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { SuSyRouter } from './router/SuSyRouter';
import { configureAmplify } from './configurations/amplify';
import { configureSentryIO } from './configurations/sentry.io';
import { getToastConfig } from './configurations/toast';
import Head from './components/common/head';

configureAmplify();
configureSentryIO();

function App() {
    return (
        <BrowserRouter>
            <Head />
            <SuSyRouter />
            <ToastContainer {...getToastConfig()} />
        </BrowserRouter>
    );
}

export default App;
